
import {
    WarningNetworkFailure,
  } from "../helpers/alertseet";
import { END_POINT_SEVER } from "../constants";
import axios from "axios";


export const getProvices = async () => {
    try {
        const url = `${END_POINT_SEVER}/api/masterdata/provinces`;
        const res = await axios.get(url);
        if(res.status === 200){
            return res.data;
        }
    } catch (error) {
        if (error.message === "Network Error") {
            WarningNetworkFailure();
        }
        console.error("error", error);
        return { error: true };
    }
};
export const getDistrictsByProvinceName = async (provinceName) => {
    try {
        const url = `${END_POINT_SEVER}/api/masterdata/get-districts-by-province`;
        const res = await axios.get(url, {
            params: {
                provinceName: provinceName
            }
        });
        if(res.status === 200){
            return res.data;
        }
    } catch (error) {
        if (error.message === "Network Error") {
            WarningNetworkFailure();
        }
        console.error("error", error);
        return { error: true };
    }
};

